<template>
  <Navbar :center-text="$t('ProfileSettingsView.profileSettings')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container mt-4">
    <form @submit.prevent="updateUserData">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12 mb-4">
          <img :src="profileImage"
               alt="Profile"
               class="profile-picture-big"/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12 form-group mb-4">
          <DropZone ref="dropZone"></DropZone>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-3 col-sm-12 form-group mb-4">
          <label for="firstname"
                 class="form-label">
            {{ $t('firstname') }}
          </label>
          <input v-model="user.firstname"
                 type="text"
                 class="form-control rounded-pill"
                 id="firstname"
                 :placeholder="$t('enterFirstname')"
                 required/>
        </div>
        <div class="col-md-3 col-sm-12 form-group mb-4">
          <label for="lastname"
                 class="form-label">
            {{ $t('lastname') }}
          </label>
          <input v-model="user.lastname"
                 type="text"
                 class="form-control rounded-pill"
                 id="lastname"
                 :placeholder="$t('enterLastname')"
                 required/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-3 col-sm-12 form-group mb-4">
          <label for="role"
                 class="form-label">
            {{ $t('ProfileSettingsView.label') }}
          </label>
          <p class="badge bg-success m-2"
             style="display: block">
            {{ user.label }}
          </p>
        </div>

        <div class="col-md-3 col-sm-12 form-group mb-4">
          <label for="role"
                 class="form-label">
            {{ $t('role') }}
          </label>
          <p class="badge bg-primary m-2"
             style="display: block">
            {{ user.role !== undefined ? user.role.name : '---' }}
          </p>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12  form-group mb-4">
          <label for="email"
                 class="form-label">
            {{ $t('email') }}
          </label>
          <input v-model="user.email"
                 type="text"
                 class="form-control rounded-pill"
                 id="email"
                 :placeholder="$t('enterEmail')"
                 required/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-2 col-sm-12 form-group mb-4">
          <label for="password" class="form-label">{{ $t('ProfileSettingsView.oldPassword') }}</label>
          <input v-model="user.oldPassword"
                 type="password"
                 class="form-control rounded-pill"
                 id="password"
                 :placeholder="$t('ProfileSettingsView.enterOldPassword')"/>
        </div>

        <div class="col-md-2 col-sm-12 form-group mb-4">
          <label for="confirmPassword" class="form-label">{{ $t('ProfileSettingsView.newPassword') }}</label>
          <input v-model="user.newPassword"
                 type="password"
                 class="form-control rounded-pill"
                 id="newPassword"
                 :placeholder="$t('ProfileSettingsView.enterNewPassword')"/>
        </div>

        <div class="col-md-2 col-sm-12 form-group mb-4">
          <label for="confirmNewPassword" class="form-label">{{ $t('ProfileSettingsView.confirmNewPassword') }}</label>
          <input v-model="user.confirmNewPassword"
                 type="password"
                 class="form-control rounded-pill"
                 id="confirmNewPassword"
                 :placeholder="$t('ProfileSettingsView.enterNewPasswordAgain')"/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12  form-group mb-4">
          <label for="Farms"
                 class="form-label">
            {{ $t('ProfileSettingsView.assignedfarms') }}
          </label>
          <ul>
            <li v-for="farm in user.assigned_farms"
                :key="farm.id"
                class="badge badge-primary m-1"
                style="background-color:#42B981; ">
              {{ farm.label }}
            </li>

            <li v-if="(user.assigned_farms === undefined) || (user.assigned_farms.length < 1)"
                class="badge badge-danger m-1">
              {{ $t('ProfileSettingsView.noFarmsAssigned') }}
            </li>
          </ul>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12 form-group">
          <button type="submit"
                  class="btn btn-success rounded-pill mb-4 w-100"
                  @click="updateUserData()">
            <i class="bi bi-plus-circle"></i> {{ $t('save') }}
          </button>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col col-md-6 col-sm-12 form-group">
          <button type="submit"
                  class="btn btn-outline-danger rounded-pill mb-4 w-100"
                  @click="deleteAccount()">
            <i class="bi bi-trash"></i> {{ $t('ProfileSettingsView.permanentlyDeleteAccount') }}
          </button>
        </div>
      </div>

    </form>
  </div>
  <Footerbar></Footerbar>
</template>

<script>

import {defineComponent} from "vue";
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {sharedState} from "@/store";
import DropZone from "@/components/DropZone.vue";
import {deleteUserData, getUserData, getUserImage, postLogout, putUserData} from "@/utils";

export default defineComponent({
  data() {
    return {
      sharedState,
      user: {},
      profileImage: null,
      message: null,
      messageType: null,
    }
  },
  components: {
    Footerbar,
    Navbar,
    DropZone
  },
  async mounted() {
    let response = await getUserData(sharedState.user_id);
    if (response.status === 200) {
      this.user = response.data;
      this.user.oldPassword = '';
      this.user.newPassword = '';
      this.user.confirmNewPassword = '';
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }

    let userImageResponse = await getUserImage(sharedState.user_id);
    if (userImageResponse.status === 200) {
      this.profileImage = URL.createObjectURL(userImageResponse.data);
    } else {
      this.message = userImageResponse.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    async updateUserData() {
      // let response = await putUserData(sharedState.user_id, this.user);
      // if (response.status === 200) {
      //   this.message = this.$t('ProfileSettingsView.userUpdateSuccess');
      //   this.messageType = "success";
      // } else {
      //   this.message = response.response.data.message;
      //   this.messageType = "danger";
      // }
      //
      // this.user.oldPassword = '';
      // this.user.newPassword = '';
      // this.user.confirmNewPassword = '';
      //
      // // Invoke the method of included component -> separate REST call for image upload.
      // this.$refs.dropZone.uploadFile();
    },
    async deleteAccount() {
      let confirmation = confirm(this.$t('ProfileSettingsView.areYouSure'));
      if (confirmation) {
        let response = await deleteUserData(sharedState.user_id);
        if (response.status === 200) {

          let response = await postLogout();
          if (response.status === 200) {
            localStorage.removeItem('user_firstname');
            localStorage.removeItem('user_id');
            localStorage.removeItem('access_token');
            localStorage.removeItem('login_timestamp');
            this.$router.push('/login');
          } else {
            this.message = response.response.data.message;
            this.messageType = 'danger';
          }

        } else {
          this.message = response.response.data.message;
          this.messageType = "danger";
        }
      }
    }
  }
})
</script>
